import React from 'react';
import { List, Switch, Button, Dialog } from 'antd-mobile';
import {
    UserOutline,
    SetOutline,
    QuestionCircleOutline,
    RightOutline,
    UnorderedListOutline,
    LockOutline
} from 'antd-mobile-icons';
import { useNavigate } from 'react-router-dom';
import { useTenant } from '@/features/tenant/context/TenantContext';
import { PageContainer, PageSection } from '@/components/layout/PageContainer';

export const MePage: React.FC = () => {
    const navigate = useNavigate();
    const { tenantCode } = useTenant();

    const handleLogout = () => {
        Dialog.confirm({
            content: '确定要退出登录吗？',
            onConfirm: () => {
                navigate(`/${tenantCode}/login`);
            },
        });
    };

    return (
        <PageContainer>
            {/* Profile Header */}
            <div className="-mx-4 px-6 py-8 flex items-center gap-4 bg-gradient-to-b from-blue-900/20 to-transparent mb-6">
                <div className="w-20 h-20 rounded-full bg-gradient-to-tr from-blue-500 to-cyan-400 p-0.5">
                    <div className="w-full h-full rounded-full bg-slate-900 border-2 border-transparent flex items-center justify-center overflow-hidden">
                        <UserOutline fontSize={40} className="text-gray-400" />
                    </div>
                </div>
                <div className="flex-1">
                    <h2 className="text-xl font-bold text-white mb-1">User_8888</h2>
                    <div className="text-xs text-gray-400 bg-white/10 px-2 py-0.5 rounded inline-block">
                        UID: 10086
                    </div>
                </div>
                <RightOutline className="text-gray-500" />
            </div>

            {/* Menu Lists */}
            <PageSection>
                <div className="rounded-2xl overflow-hidden glass mb-4">
                    <List className="bg-transparent" style={{ '--adm-color-text': '#ffffff' }}>
                        <List.Item
                            prefix={<LockOutline className="text-green-400" />}
                            onClick={() => { }}
                            arrow
                            style={{ color: '#ffffff' }}
                        >
                            <span style={{ color: '#ffffff' }}>安全中心</span>
                        </List.Item>
                        <List.Item
                            prefix={<UnorderedListOutline className="text-blue-400" />}
                            onClick={() => { }}
                            arrow
                            style={{ color: '#ffffff' }}
                        >
                            <span style={{ color: '#ffffff' }}>常用地址管理</span>
                        </List.Item>
                    </List>
                </div>
            </PageSection>

            <PageSection>
                <div className="rounded-2xl overflow-hidden glass">
                    <List style={{ '--adm-color-text': '#ffffff' }}>
                        <List.Item
                            prefix={<SetOutline className="text-gray-400" />}
                            extra={<Switch defaultChecked style={{ '--checked-color': '#10b981' }} />}
                            style={{ color: '#ffffff' }}
                        >
                            <span style={{ color: '#ffffff' }}>暗黑模式</span>
                        </List.Item>
                        <List.Item
                            prefix={<QuestionCircleOutline className="text-gray-400" />}
                            onClick={() => { }}
                            arrow
                            style={{ color: '#ffffff' }}
                        >
                            <span style={{ color: '#ffffff' }}>帮助与反馈</span>
                        </List.Item>
                    </List>
                </div>
            </PageSection>

            <Button
                block
                color="danger"
                fill="outline"
                size="large"
                className="mt-8 border-red-500/30 text-red-500 active:bg-red-500/10"
                onClick={handleLogout}
            >
                退出登录
            </Button>

            <div className="text-center text-xs text-gray-600 mt-8 mb-4">
                Version 1.0.0 (Build 20231212)
            </div>
        </PageContainer>
    );
};
